"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M10.724 11.258h1.941a3.22 3.22 0 0 0 3.217-3.217 3.222 3.222 0 0 0-2.94-3.205A4.961 4.961 0 0 0 8.004.316c-2.564 0-4.68 1.958-4.929 4.52A3.22 3.22 0 0 0 .132 8.04a3.22 3.22 0 0 0 3.217 3.217h2.144v-1H3.35A2.22 2.22 0 0 1 1.132 8.04c0-1.277 1.122-2.31 2.38-2.208l.538-.021V5.27a3.96 3.96 0 0 1 3.955-3.955c2.181 0 3.955 1.774 3.954 4.019v.54l.54-.042c1.24-.1 2.383.929 2.383 2.208a2.22 2.22 0 0 1-2.217 2.217h-1.94v1ZM7.471 13.82V7.604h1v6.314l.615-1.001.72.692-1.821 2.08-1.956-2.064.692-.721.75.917Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M14.662 17.799h4.562A4.782 4.782 0 0 0 24 13.023a4.783 4.783 0 0 0-4.545-4.771c-.245-3.9-3.496-6.998-7.457-6.998S4.787 4.353 4.54 8.253A4.782 4.782 0 0 0 0 13.023a4.782 4.782 0 0 0 4.776 4.776h4.877v-1.125H4.776a3.655 3.655 0 0 1-3.651-3.651 3.655 3.655 0 0 1 3.651-3.651c.083 0 .165.006.259.013h.015l.601-.053v-.605c0-3.5 2.847-6.348 6.347-6.348 3.5 0 6.347 2.848 6.347 6.348h.552v.001l-.555.09-.007.615.612-.046a3.36 3.36 0 0 1 .277-.015 3.655 3.655 0 0 1 3.651 3.65 3.655 3.655 0 0 1-3.651 3.652h-4.562v1.125Zm-2.155 2.754 1.319-1.372.81.779-2.676 2.785-2.88-2.767.779-.812 1.523 1.464v-8.285h1.125v8.208Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M19.55 23.731h6.082A6.376 6.376 0 0 0 32 17.363a6.377 6.377 0 0 0-6.06-6.36c-.327-5.2-4.662-9.33-9.943-9.33s-9.615 4.13-9.942 9.33A6.376 6.376 0 0 0 0 17.363a6.376 6.376 0 0 0 6.368 6.368h6.502v-1.5H6.368A4.874 4.874 0 0 1 1.5 17.363a4.874 4.874 0 0 1 4.868-4.868c.111 0 .22.009.345.018l.02.001.802-.072v-.807c0-4.666 3.796-8.463 8.462-8.463s8.463 3.797 8.463 8.463h.736v.002l-.74.121-.009.82.816-.063c.122-.01.244-.02.369-.02a4.874 4.874 0 0 1 4.868 4.868 4.874 4.874 0 0 1-4.868 4.868H19.55v1.5Zm-2.875 3.673 1.76-1.83 1.08 1.04-3.569 3.713-3.84-3.69 1.04-1.082 2.03 1.951V16.46h1.5v10.944Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M29.37 35.536h9.196c5.203 0 9.434-4.232 9.434-9.433 0-5.108-4.081-9.281-9.154-9.43-.4-7.844-6.908-14.103-14.85-14.103-7.943 0-14.45 6.26-14.85 14.104C4.075 16.826 0 20.998 0 26.103c0 5.201 4.231 9.433 9.434 9.433h9.832v-1.875H9.434c-4.168 0-7.559-3.39-7.559-7.558 0-4.168 3.39-7.559 7.559-7.559.169 0 .336.013.537.027l.03.003 1.022.075-.022-1.21c0-7.164 5.83-12.994 12.995-12.994 7.164 0 12.994 5.83 12.994 12.995l-.005.19.004 1.02 1.019-.076.026-.002c.176-.014.353-.028.532-.028 4.168 0 7.559 3.391 7.559 7.559s-3.39 7.558-7.559 7.558H29.37v1.875Zm-4.555 6.215 2.974-3.096 1.352 1.3-5.261 5.474-5.666-5.445 1.3-1.351 3.426 3.292V24.736h1.875v17.015Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M39.159 47.382h12.263C58.358 47.382 64 41.739 64 34.804c0-6.811-5.442-12.375-12.206-12.572-.533-10.46-9.21-18.805-19.8-18.805s-19.267 8.346-19.8 18.805C5.435 22.435 0 27.997 0 34.804c0 6.935 5.642 12.578 12.578 12.578h13.11v-2.5h-13.11C7.021 44.882 2.5 40.36 2.5 34.804c0-5.557 4.521-10.078 10.078-10.078.226 0 .448.016.716.036l.04.003 1.363.1-.029-1.612c0-9.553 7.773-17.326 17.326-17.326S49.32 13.7 49.32 23.253l-.007.253.005 1.36 1.359-.101.035-.003a9.18 9.18 0 0 1 .71-.036c5.557 0 10.078 4.52 10.078 10.078 0 5.557-4.521 10.078-10.078 10.078H39.159v2.5Zm-6.072 8.285 3.965-4.127 1.803 1.733-7.015 7.3-7.555-7.26 1.733-1.803 4.569 4.39V32.981h2.5v22.686Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconDownload = function IconDownload(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Download' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Download"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconDownload.sizes = [16, 24, 32, 48, 64];
IconDownload.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconDownload;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/system/Download.js
// module id = 2363
// module chunks = 0